module.exports = __webpack_public_path__ + "img/covidBanner.5045a85a.jpg";